export default {
  username: 'Username',
  password: 'Password',
  submit: 'Login',
  continue: 'Continue without logging in',
  // error: 'Incorrect username or password',
  error:
    "C'è un errore oppure l'username o la password sono errati.<br/> La pagina verrà ricaricata tra qualche secondo oppure procedi manualmente.",
}
